import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useUID } from 'react-uid';
import { PaymentService } from 'config';
import Braintree from 'services/Braintree';
import type { OnToken } from 'services/Braintree';

type Props = {
  show: boolean;
  standalone?: boolean;
  onToken: OnToken;
};

function GooglePayProvider({
  show,
  standalone = false,
  onToken,
}: Props): ReactElement {
  const uid = useUID();

  useEffect(() => {
    const elementId = `payment-method-google-pay-${uid}`;
    const element = document.getElementById(elementId);

    if (show && element) {
      Braintree.renderGooglePay(
        `#${elementId}`,
        (token, address) => onToken(PaymentService.GOOGLE_PAY, token, address),
      );
    }
  }, [uid, show, onToken]);
  // @ts-expect-error TODO: fix null safety
  return show && (
    standalone ? (
      <div id={`payment-method-google-pay-${uid}`} />
    ) : (
      <div
        className={[
          'c-payment-form__body',
          'c-payment-form__body--google-pay',
          'collapse',
          'show',
        ].join(' ')}
      >
        <div className="c-alternative-payment-buttons">
          <div>
            <div id={`payment-method-google-pay-${uid}`} />
          </div>
        </div>
      </div>
    )
  );
}

export default GooglePayProvider;
